<!-- Container -->
<section class="section container-fluid">
	<div class="d-flex flex-column align-items-center justify-content-center nav-container position-relative mt-0">
		<nav
			ngbNav
			#nav="ngbNav"
			#navTabs
			class="nav-tabs bg-white w-100"
			[activeId]="selectedLegalPage"
			(activeIdChange)="navChange($event)"
		>
			<!-- Cookie Usage -->
			<ng-container
				*ngIf="!this.config.disabledPages.includes(EnumLegalPageRoute.CookiesUsage)"
				[ngbNavItem]="EnumLegalPageRoute.CookiesUsage"
			>
				<button
					ngbNavLink
					[routerLink]="EnumLegalPageRoute.CookiesUsage"
				>
					{{ pageTitles[EnumLegalPageRoute.CookiesUsage] }}
				</button>
				<ng-template ngbNavContent>
					<legal-cookies-usage [content]="cookiesContent"></legal-cookies-usage>
				</ng-template>
			</ng-container>

			<!-- Privacy Policy -->
			<ng-container
				*ngIf="!this.config.disabledPages.includes(EnumLegalPageRoute.PrivacyPolicy)"
				[ngbNavItem]="EnumLegalPageRoute.PrivacyPolicy"
			>
				<button
					ngbNavLink
					[routerLink]="EnumLegalPageRoute.PrivacyPolicy"
				>
					{{ pageTitles[EnumLegalPageRoute.PrivacyPolicy] }}
				</button>
				<ng-template ngbNavContent>
					<legal-privacy-policy [content]="privacyContent"></legal-privacy-policy>
				</ng-template>
			</ng-container>

			<!-- Cancellation Policy -->
			<ng-container
				*ngIf="!this.config.disabledPages.includes(EnumLegalPageRoute.CancellationPolicy)"
				[ngbNavItem]="EnumLegalPageRoute.CancellationPolicy"
			>
				<button
					ngbNavLink
					[routerLink]="EnumLegalPageRoute.CancellationPolicy"
				>
					{{ pageTitles[EnumLegalPageRoute.CancellationPolicy] }}
				</button>
				<ng-template ngbNavContent>
					<legal-cancellation-policy [content]="cancellationContent"></legal-cancellation-policy>
				</ng-template>
			</ng-container>

			<!-- Terms Of Use -->
			<ng-container
				*ngIf="!this.config.disabledPages.includes(EnumLegalPageRoute.TermsOfUse)"
				[ngbNavItem]="EnumLegalPageRoute.TermsOfUse"
			>
				<button
					ngbNavLink
					[routerLink]="EnumLegalPageRoute.TermsOfUse"
				>
					{{ pageTitles[EnumLegalPageRoute.TermsOfUse] }}
				</button>
				<ng-template ngbNavContent>
					<legal-terms-of-use [content]="termsOfUseContent"></legal-terms-of-use>
				</ng-template>
			</ng-container>

			<!-- Affiliate Terms -->
			<ng-container
				*ngIf="!this.config.disabledPages.includes(EnumLegalPageRoute.AffiliateTerms) && config.affiliateTerms"
				[ngbNavItem]="EnumLegalPageRoute.AffiliateTerms"
			>
				<button
					ngbNavLink
					[routerLink]="EnumLegalPageRoute.AffiliateTerms"
				>
					{{ pageTitles[EnumLegalPageRoute.AffiliateTerms] }}
				</button>
				<ng-template ngbNavContent>
					<legal-affiliate-terms [content]="affiliateContent"></legal-affiliate-terms>
				</ng-template>
			</ng-container>

			<!-- Imprint / Legal Notice -->
			<ng-container
				*ngIf="!this.config.disabledPages.includes(EnumLegalPageRoute.Imprint)"
				[ngbNavItem]="EnumLegalPageRoute.Imprint"
			>
				<button
					ngbNavLink
					[routerLink]="EnumLegalPageRoute.Imprint"
				>
					{{ pageTitles[EnumLegalPageRoute.Imprint] }}
				</button>
				<ng-template ngbNavContent>
					<legal-imprint [content]="imprintContent"></legal-imprint>
				</ng-template>
			</ng-container>
		</nav>

		<!-- Navbar renderer -->
		<div
			class="container"
			[ngbNavOutlet]="nav"
		></div>
	</div>
</section>
